import { Directive } from '@angular/core';
import { NG_VALIDATORS, Validator, FormControl, ValidationErrors } from '@angular/forms';


@Directive({
  // tslint:disable-next-line:directive-selector
  selector: '[invalidCellPhoneNumber]',
  providers: [{ provide: NG_VALIDATORS, useExisting: CellphoneValidator, multi: true }]
})
export class CellphoneValidator implements Validator {

  public static valid(c: FormControl): ValidationErrors {
    if (c.value) {
      const rawValue = String(c.value).trim();
      const digits = rawValue.replace(/\D/g, '');

      if (!digits) {
        return { 'invalidCellPhoneNumber': true };
      }

      const nationalNumber = digits.startsWith('549') ? digits.substring(3) : digits;
      const isValidPhoneNumber = CellphoneValidator.isValidNationalNumber(nationalNumber);

      return !isValidPhoneNumber ? { 'invalidCellPhoneNumber': true } : null;
    } else { return null; }
  }

  private static isValidNationalNumber(nationalNumber: string): boolean {
    for (let areaLength = 2; areaLength <= 4; areaLength++) {
      const localLength = nationalNumber.length - areaLength;
      if (localLength >= 6 && localLength <= 8) {
        return true;
      }
    }

    return false;
  }

  validate(c: FormControl): ValidationErrors {
    return CellphoneValidator.valid(c);
  }
}
